/* meliora trust band + contact/quote  (2026-08-10) part 1/2
   data + product loader + builders. Paired with meliora-trust-forms-2.js.
   2026-10-06: 安心バッジの「送料無料」「3営業日以内に発送」を商品ごとに出し分け
   （snippets/mlr-product-tabs.liquid が出す #mlr-product-meta を読む）。 */
(function () {
  'use strict';
  var N = window.__MLR = window.__MLR || {};

  N.SVG_TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M1 5h13v10H1z"/><path d="M14 8h4l3 3v4h-7"/><circle cx="5.5" cy="18" r="1.7"/><circle cx="17.5" cy="18" r="1.7"/></svg>';
  N.SVG_CLOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5l3.2 2"/></svg>';
  N.SVG_BUILD = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"/><path d="M5 21V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v16"/><path d="M15 9h3a1 1 0 0 1 1 1v11"/><path d="M8 8h2M8 12h2M8 16h2"/></svg>';
  N.SVG_MAIL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3.5 7 8.5 6 8.5-6"/></svg>';

  N.PRODUCT = { title: '', sku: '', url: location.origin + location.pathname };
  N.variantSku = {};

  N.escapeHtml = function (s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  N.setFormMeta = function () {
    var src = document.getElementById('meliora-forms-src');
    if (!src) return;
    src.querySelectorAll('.mf-title').forEach(function (i) { i.value = N.PRODUCT.title; });
    src.querySelectorAll('.mf-sku').forEach(function (i) { i.value = N.PRODUCT.sku; });
    src.querySelectorAll('.mf-url').forEach(function (i) { i.value = N.PRODUCT.url; });
  };

  N.currentVariantId = function () {
    var sel = document.querySelector('#add-item-form [name="id"]');
    return sel ? String(sel.value) : '';
  };

  N.refreshSku = function () {
    var id = N.currentVariantId();
    if (id && N.variantSku[id]) N.PRODUCT.sku = N.variantSku[id];
    N.setFormMeta();
  };

  N.loadProduct = function () {
    var t = document.querySelector('#product h1.title, #product [itemprop="name"]');
    N.PRODUCT.title = t ? t.textContent.trim() : '';
    N.setFormMeta();
    fetch(location.pathname.split('?')[0] + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        if (p.title) N.PRODUCT.title = p.title;
        (p.variants || []).forEach(function (v) { N.variantSku[String(v.id)] = v.sku || ''; });
        N.refreshSku();
        var sel = document.querySelector('#add-item-form [name="id"]');
        if (sel) sel.addEventListener('change', N.refreshSku);
      })
      .catch(function () {});
  };

  N.buildTrust = function () {
    if (document.querySelector('.meliora-trust')) return;
    var ps = document.querySelector('#add-item-form .purchase-section') || document.querySelector('.purchase-section');
    if (!ps) return;
    // 商品ごとの出し分け（テンプレートが出す #mlr-product-meta）。無ければ従来の全商品共通表示
    var meta = document.getElementById('mlr-product-meta');
    var isFree = !meta || meta.getAttribute('data-free') === '1';
    var delivery = meta ? (meta.getAttribute('data-delivery') || '').trim() : '';
    var shipHtml = isFree
      ? '<b>全国送料無料</b><small>北海道・沖縄・離島を除く</small>'
      : '<b>5,000円以上で送料無料</b><small>北海道・沖縄・離島を除く</small>';
    var deliveryHtml = delivery
      ? '<b>' + N.escapeHtml(delivery) + '</b><small>この商品は納期が異なります</small>'
      : '<b>3営業日以内に発送</b><small>在庫状況により変動</small>';
    var wrap = document.createElement('div');
    wrap.className = 'meliora-trust';
    wrap.innerHTML =
      '<a class="mtrust-item" href="/pages/shipping">' + N.SVG_TRUCK +
        '<span class="mtrust-tx">' + shipHtml + '</span></a>' +
      '<div class="mtrust-item">' + N.SVG_CLOCK +
        '<span class="mtrust-tx">' + deliveryHtml + '</span></div>' +
      '<div class="mtrust-item">' + N.SVG_BUILD +
        '<span class="mtrust-tx"><b>法人お見積り対応</b><small>大量注文もお気軽に</small></span></div>';
    ps.insertBefore(wrap, ps.firstChild);
  };

  N.buildQuoteBtn = function () {
    if (document.querySelector('.meliora-quote-cta')) return;
    var scope = document.querySelector('.product-description') || document;
    var bikou = null;
    var cells = scope.querySelectorAll('td, th, dt');
    for (var i = 0; i < cells.length; i++) {
      if (cells[i].children.length === 0 && cells[i].textContent.trim() === '備考') { bikou = cells[i]; break; }
    }
    var anchor = null;
    if (bikou) anchor = bikou.closest('table') || bikou;
    if (!anchor) anchor = document.querySelector('.product-description .container') || document.querySelector('.product-description');
    if (!anchor || !anchor.parentNode) return;
    var box = document.createElement('div');
    box.className = 'meliora-quote-cta';
    box.innerHTML =
      '<p class="mqc-lead">法人・大量注文をご検討のお客様へ</p>' +
      '<button type="button" class="meliora-btn meliora-btn-quote">' + N.SVG_BUILD + '<span>法人お見積りを依頼する</span></button>';
    anchor.parentNode.insertBefore(box, anchor.nextSibling);
    box.querySelector('.meliora-btn-quote').addEventListener('click', function () { N.openModal('quote'); });
  };

  N.buildInquiryBtn = function () {
    if (document.querySelector('.meliora-inquiry-cta')) return;
    // place a full-width secondary button directly under the cart button
    var cart = document.querySelector('#add-item-form .purchase-section .purchase')
            || document.querySelector('.purchase-section .purchase')
            || document.querySelector('#add-item-form .purchase-section')
            || document.querySelector('.purchase-section');
    if (!cart || !cart.parentNode) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'meliora-inquiry-cta';
    b.innerHTML = N.SVG_MAIL + '<span>この商品について問い合わせ</span>';
    b.addEventListener('click', function () { N.openModal('inquiry'); });
    cart.parentNode.insertBefore(b, cart.nextSibling);
    // unify rounded corners on theme-locked elements (inline !important wins)
    var cartBtn = document.getElementById('add-to-cart');
    if (cartBtn) cartBtn.style.setProperty('border-radius', '8px', 'important');
    document.querySelectorAll('#product .wishlist').forEach(function (w) {
      w.style.setProperty('border-radius', '8px', 'important');
    });
  };

  // remove empty "（）" from category chips (e.g. series:xxx tags with no JP label)
  N.cleanTags = function () {
    document.querySelectorAll('.product-collection .--ja').forEach(function (s) {
      if (s.textContent.replace(/[（）()\s]/g, '') === '') s.remove();
    });
  };
})();
